import React from 'react';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import Title from './Title';

interface Props {
    isOpen:boolean,
}

const Denied:React.FC<Props> = (props)=> {
	
    if( !props.isOpen ){
        return (null);
    }

	const close = ()=>{

    }

	return (
		<Dialog
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={false}
			onClose={close}
		>
			<DialogTitle color='primary'>サーバとの接続が切れました</DialogTitle>
			<DialogContent>
				<div>
					接続が切れた理由は、例えば以下のようなものが挙げられます<br/>
				</div>
				<div style={{marginTop:"10px",fontSize:"0.9em",padding:'1em',backgroundColor:'#f8d7da',color:'#721c24'}}>
					・サーバに障害が発生した<br/>
					・セッションがタイムアウトした<br/>
					・複数の環境から同時にアクセスした<br/>
					・ブラウザのキャッシュが削除された<br/>
				</div>
				<div style={{marginTop:"3em"}}>
					お手数ですがリロードしてやり直してください<br/>
					<span style={{fontSize:'0.9em'}}>（再度ログインが必要になる場合もあります）</span><br/>
				</div>
				<div style={{textAlign:"center",marginTop:"20px"}}>
				<Button variant="contained" color="primary"onClick={() => window.location.reload()}>

					リロード
				</Button>
				</div>
			</DialogContent>
        </Dialog>

    );
}

export default Denied;
